import { Highlight } from '../Highlight';
import { CellRenderer, CellRenderProps, CellValue } from '../types';

import { DocumentFileLink, isViewableDocument } from './DocumentFileLink';
import styles from './longtext.module.scss';

const LONGTEXT_MEDIAN_THRESHOLD = 200;

const median = (nums: number[]): number => {
  if (nums.length === 0) return 0;
  const sorted = [...nums].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
};

const looksStructured = (value: string): boolean => {
  const trimmed = value.trimStart();
  if (trimmed.startsWith('{') || trimmed.startsWith('[')) return true;
  if (/^#{1,6}\s/m.test(value)) return true;
  if (/\|.*\|/.test(value)) return true;
  if (/```/.test(value)) return true;
  return false;
};

const detect = (samples: CellValue[]): boolean => {
  const strings = samples.filter((s): s is string => typeof s === 'string' && s !== '');
  if (strings.length === 0) return false;
  if (strings.some(looksStructured)) return false;
  return median(strings.map(s => s.length)) > LONGTEXT_MEDIAN_THRESHOLD;
};

const Compact = ({ value }: CellRenderProps) => (
  <span className={styles.compact}>
    <Highlight text={String(value)} />
  </span>
);

const Block = ({ value }: CellRenderProps) => {
  const text = String(value);
  return (
    <div className={styles.block}>
      <Highlight text={text} />
      {isViewableDocument(text) && <DocumentFileLink filename={text} />}
    </div>
  );
};

export const longtextRenderer: CellRenderer = {
  kind: 'longtext',
  detect,
  Compact,
  Expanded: Block,
  Full: Block,
};
